import "./withdraw.css";
import WithdrawCard from "./WithdrawCard";
import { useState, useEffect } from "react";
import Toaster from "../../../../Toast/Toast";
import {
  paymentSuccess,
  setPaymentType,
} from "../../../../../redux/slices/paymentSlice";
import { useDispatch, useSelector } from "react-redux";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import BackdropLoader from "../../../../BackdropLoader/BackdropLoader";
import { togglePayment } from "../../../../../redux/slices/accountSlice";
import {
  getCart,
  userVerificationEmail,
  WithDraw,
} from "../../../../../api/modules/b2droppie.class";
import CommonModal from "../../../../CommonModal/CommonModal";

const WithdrawTab = ({ hidemodal }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const [totalPrice, setTotalPrice] = useState(0);
  const [toastMessage, setToastMessage] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const user = useSelector((state) => state?.auth?.user);
  const isDarkMode = useSelector((state) => state.theme.darkMode);
  const [showVerifyEmailModal, setShowVerifyEmailModal] = useState(false);

  useEffect(() => {
    try {
      const api = async () => {
        const response = await getCart({ id: user?.id, page: "all" });
        setData(response?.data?.data);
        setLoading(false);
      };
      api();
    } catch (err) {
      console.log(err);
    }
  }, []);

  const handleNextClick = async (items) => {
    if (!items || items.length === 0) return;

    if (totalPrice < 1.02) {
      setToastMessage({ error: "Minimum withdraw amount is $1.02" });
      return;
    }

    try {
      setLoading(true);

      const product_id = items.map((item) => item.id);
      const quantities = {};

      items.forEach((item) => {
        quantities[item.id] = item.quantity || 1;
      });

      const response = await WithDraw({
        product_id,
        quantities,
        payment_amount: totalPrice,
      });

      if (response?.data?.success) {
        setToastMessage({ success: response.data.data.message });
        dispatch(paymentSuccess(response?.data?.data));
        dispatch(setPaymentType("withdraw"));
        dispatch(togglePayment());
      }
    } catch (err) {
      console.log(err);
      if (err?.status === 403) {
        setShowVerifyEmailModal(true);
      }
      setToastMessage({
        error: err?.response?.data?.message || "Withdraw failed",
      });
    } finally {
      setLoading(false);
    }
  };

  const userEmailVerification = async () => {
    try {
      const response = await userVerificationEmail({
        email: user?.email,
      });
      setToastMessage({
        success: response?.data?.message || "",
        error: response?.data?.error?.message || "",
      });
      if (response?.data?.success) {
        setShowVerifyEmailModal(false);
      }
    } catch (err) {
      console.error(err);
      setToastMessage({
        success: "",
        error: "Something went wrong. Try again.",
      });
    } finally {
      setLoading(false);
      setShowVerifyEmailModal(false);
    }
  };

  return (
    <>
      <Toaster message={toastMessage} />
      <div>
        <div className="px-4 py-2 d-start gap-2">
          <h4
            className={`mb-0  ${
              isDarkMode ? "deposit-heading-dark" : "deposit-heading-light"
            }`}
            style={{
              fontWeight: "700",
              textTransform: "capitalize",
              color: isDarkMode ? "#fff" : "#684199",
            }}
          >
            Withdraw
          </h4>
          <p className="ml-2 mb-0">
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id="tooltip-verify">
                  Hover over the items to change quantity before withdrawing
                </Tooltip>
              }
            >
              <i className="fa-solid fa-circle-info cursor-pointer text-secondary"></i>
            </OverlayTrigger>
          </p>
        </div>

        <div className="select-items-div">
          <BackdropLoader show={loading} />
          <WithdrawCard
            data={data}
            hidemodal={hidemodal}
            totalPrice={totalPrice}
            setTotalPrice={setTotalPrice}
            selectedItems={selectedItems}
            handleNextClick={handleNextClick}
            setSelectedItems={setSelectedItems}
          />
        </div>
      </div>

      <CommonModal
        show={showVerifyEmailModal}
        onClose={() => setShowVerifyEmailModal(false)}
        onConfirm={() => userEmailVerification()}
        title={
          <h4
            className={`${isDarkMode ? "text-light-lavender-purple" : "text-deep-purple"} w-100 d-center`}
          >
            Email not Verified!
          </h4>
        }
        body={
          <>
            <p
              className={`${isDarkMode ? "text-muter-lavender-purple" : "text-charcoal-gray"} mb-2`}
            >
              Please verify your email address. Click Here to generate an email.
            </p>
          </>
        }
        showFooter={true}
        modalWidth="w-lg-35"
        isDarkMode={isDarkMode}
        confirmText="Send Email!"
        btnStyle="filled-danger-btn-dark"
      />
    </>
  );
};

export default WithdrawTab;
